const locale = require('./snippetsViewer.i18n.json');

/*@ngInject*/
const SnippetsViewerController = function ($rootScope, $scope, $stateParams, $timeout, formMediator, formViewerConstant,
                                                          submissionConstant, submissionStatus, submissionMediator,
                                                          submissionStateMediator, formatUtil) {
    const timeoutList=[];

    this.$onInit = function () {
        this.i18n = locale;
        this.currentSnippets = [];
        this.fieldsSnippets = [];
        this.isDetached = false;
        this.isOpen = false;
        this.isActive = true;
        this.currentField = false;
        this.isReady = false;
        this.currentSnippetSignature = null;
        this.snippetsBlobCache = {};

        $scope.$on(formViewerConstant.event.FOCUSED_FIELD_CHANGED, this.updateCurrentField.bind(this));

        $scope.$on(formViewerConstant.event.FORM_DATA_READY, this.updateCurrentForm.bind(this));

        $scope.$watch('$ctrl.isActive', this.resetViewer.bind(this));

        $scope.$on(submissionConstant.event.TOGGLE_SNIPPETS, this.toggleViewer.bind(this));
        $scope.$on(submissionConstant.event.CLOSE_SNIPPETS, this.closeViewer.bind(this));

        $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
            if (toState.url.indexOf(':formId') === -1) {
                this.resetViewer();
            } else {
                this.emptyViewer();
                this.reloadViewerState(true);
            }
        }.bind(this));

        this.reloadViewerState();
    };

    this.updateCurrentForm = function (event, formData, rootFormId) {
        var submission = submissionMediator.getCurrentSubmission();

        if (!_.isNil(submission)) {
            this.isReady = true;
            this.currentSnippets = [];

            if (submission.status !== submissionStatus.CREATED_SUBMISSION) {
                this.fieldsSnippets = formData.snippetList;

                if (this.fieldsSnippets.length <= 0) {
                    this.closeViewer();
                } else if (this.isFormLevelSnippet()) {
                    this.loadAllFormLevelSnippetBlobs();
                }

                $rootScope.$broadcast(submissionConstant.event.REFRESH_SNIPPETS_TOGGLER, this.fieldsSnippets);
                this.isActive = true;
            } else {
                this.isActive = false;
                this.fieldsSnippets = [];
                this.closeViewer();
                $rootScope.$broadcast(submissionConstant.event.REFRESH_SNIPPETS_TOGGLER, this.fieldsSnippets);
            }
        }
    };

    this.updateCurrentField = function (e, fieldData) {
        if (!this.isActive) {
            return;
        }

        var fieldName = _.get(fieldData, 'uiField.fieldTemplate.variableName');
        var snippets = _.filter(this.fieldsSnippets, function (fieldSnippet) {
            return fieldSnippet.fieldName === fieldName || fieldSnippet.fieldName === '*';
        });

        this.currentField = fieldData;
        this.currentSnippets = [];

        if (snippets) {
            this.currentSnippets = _.flatten([snippets]);
            this.loadAllCurrentSnippetBlobs();
        }

        this.setCurrentSnippetField();
    };

    this.toggleViewer = function () {
        return (this.isOpen) ? this.closeViewer() : this.showViewer();
    };

    this.emptyViewer = function () {
        this.currentField = false;
        this.currentSnippets = [];
        this.setCurrentSnippetField();
    };

    this.resetViewer = function () {
        this.closeViewer();
        this.emptyViewer();
        this.fieldsSnippets = [];
        $rootScope.$broadcast(submissionConstant.event.REFRESH_SNIPPETS_TOGGLER, this.fieldsSnippets);

        if ($stateParams.formId) {
            var rootFormId = $stateParams.formId;
            var formData = formMediator.getFormStructure(rootFormId);
            if (formData) {
                this.updateCurrentForm(null, formData, rootFormId);
            }
        }
    };

    this.closeViewer = function () {
        this.isOpen = false;
        this.attachViewer();

        $rootScope.$broadcast(submissionConstant.event.SNIPPETS_DID_CLOSE);

        this.setCurrentSnippetField();
        this.saveState();
    };

    this.showViewer = function () {
        this.isOpen = true;
        $rootScope.$broadcast(submissionConstant.event.SNIPPETS_DID_OPEN);

        if (this.currentField) {
            this.setCurrentSnippetField();
            this.loadAllCurrentSnippetBlobs();
        } else if (this.isFormLevelSnippet()) {
            this.loadAllFormLevelSnippetBlobs();
        }
        this.saveState();
    };

    this.isFormLevelSnippet = function () {
        var isFormLevel = false;
        _.each(this.fieldsSnippets, function (snippet) {
            if (snippet.fieldName === '*') {
                isFormLevel = true;
            }
        });
        return isFormLevel;
    };


    this.detachViewer = function () {
        this.isDetached = true;
        this.showViewer();
        this.saveState();
    };

    this.attachViewer = function () {
        this.isDetached = false;
        this.saveState();
    };

    this.loadAllCurrentSnippetBlobs = function () {
        this.loadAllCurrentSnippetBlobContinue(this.currentSnippets, false);
    };

    this.loadAllFormLevelSnippetBlobs = function () {
        this.currentSnippets = [];
        this.loadAllCurrentSnippetBlobContinue(this.fieldsSnippets, true);
    };

    this.loadAllCurrentSnippetBlobContinue = function (snippets, isFormLevel) {
        _.each(snippets, function (snippet) {

            if (isFormLevel && snippet.fieldName !== '*') {
                return;
            }

            if (this.currentSnippets.indexOf(snippet)<0 && !_.isNil(snippet.imageBlob)) {
                this.currentSnippets.push(snippet);
                return;
            }

            var currentBlob = _.get(this.snippetsBlobCache, snippet.magicEyeImageBlobFileId);
            if (!currentBlob) {
                snippet.loading = true;
                formMediator.getSnippetBlob(snippet.id).then(function (blob) {
                    snippet.imageBlob = false;
                    if (blob) {
                        snippet.imageBlob = 'data:image/png;base64,' + blob;
                        this.snippetsBlobCache[snippet.magicEyeImageBlobFileId] = snippet.imageBlob;
                    }
                }.bind(this))
                    .finally(function () {
                        timeoutList.push($timeout(function () {snippet.loading = false;}, 0));
                    });
            } else {
                snippet.imageBlob = currentBlob;
            }

            if (this.currentSnippets.indexOf(snippet)<0 && isFormLevel) {
                this.currentSnippets.push(snippet);
            }

        }.bind(this));
    };

    this.getSnippetsSignature = function () {
        return _.map(this.currentSnippets, 'blobFileId').join('-');
    };

    this.saveState = function () {
        var currentState = submissionStateMediator.getSnippetsViewerPositionState($stateParams.submissionId) || {};

        currentState = _.extend(currentState, {
            isOpen: this.isOpen,
            isDetached: this.isDetached
        });

        submissionStateMediator.saveSnippetsViewerPositionState($stateParams.submissionId, currentState);
    };

    this.reloadViewerState = function (sendEvent) {
        var currentState = submissionStateMediator.getSnippetsViewerPositionState($stateParams.submissionId) || {};
        this.isOpen = _.get(currentState, 'isOpen', false);
        this.isDetached = _.get(currentState, 'isDetached', false);

        if (!sendEvent) {
            return;
        }

        if (this.isOpen) {
            this.showViewer();
        }

        if (this.isDetached) {
            this.detachViewer();
        }
    };

    this.setCurrentSnippetField = function () {
        var fieldName, hasSnippets, fieldNameClass;

        if (this.isActive) {
            fieldName = _.get(this.currentField, 'uiField.fieldTemplate.variableName', null);
            hasSnippets = (this.currentSnippets.length > 0);
            fieldNameClass = `formFieldComponent-${formatUtil.formatAsSelector(fieldName)}`;
        }

        $rootScope.$broadcast(submissionConstant.event.SET_CURRENT_SNIPPET_FIELD, fieldNameClass, hasSnippets, this.isOpen);
    };

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });

};


angular.module('gw-um-submission')
    .controller('snippetsViewerController', SnippetsViewerController);
